const React = require('react');

const Utils = {
  isNodeInRoot(node, root) {
    let currentNode = node;

    while (currentNode) {
      if (currentNode === root) {
        return true;
      }

      currentNode = currentNode.parentNode;
    }

    return false;
  },

  diffReactChildren(groupA, groupB) {
    const rv = [];
    React.Children.forEach(groupA, (itemA) => {

      // poor man's some()
      let exists = false;
      React.Children.forEach(groupB, (itemB) => {
        if (itemA.key === itemB.key) {
          exists = true;
        }
      });

      if (!exists) {
        rv.push(itemA);
      }
    });

    return rv;
  },

  uniqueIdCounter: 0,
  uniqueId(namespace = 'vogue-unique-id') {
    return `${ namespace.toLowerCase() }-${ Utils.uniqueIdCounter++ }`;
  },
};

module.exports = Utils;
